import { Form } from '@style/common/form';
import { ButtonLightTheme } from '@style/components/button';
import { DividerLightTheme } from '@style/components/divider';
import { MenuLightTheme } from '@style/components/menu';
import { RadioLightTheme } from '@style/components/radio';
import { SelectLightTheme } from '@style/components/select';
import { SidebarLightTheme } from '@style/components/sidebar';
import { StepsLightTheme } from '@style/components/steps';
import { SwitchLightTheme } from '@style/components/switch';
import { TableLightTheme } from '@style/components/table';
import { TitleLightTheme } from '@style/components/title';
import { StyleConfigInterface } from '@style/style.interfaces';

export const lightThemeConfig: StyleConfigInterface = {
  components: {
    Button: ButtonLightTheme,
    Divider: DividerLightTheme,
    Form,
    Menu: MenuLightTheme,
    Radio: RadioLightTheme,
    Select: SelectLightTheme,
    Sidebar: SidebarLightTheme,
    Steps: StepsLightTheme,
    Switch: SwitchLightTheme,
    Table: TableLightTheme,
    Tabs: TableLightTheme,
    Title: TitleLightTheme,
  },
};
